<template>
  <div class="report-view" :class="{ 'pdf-report-loading': printingReport }">
    <div class="dash-header">
      <h1>
        <i class="far fa-user-chart"></i>
        Capacidad y productividad
        <span v-html="filtersRequiredSet ? filtersHead : 'Seleccione los filtros para los datos del reporte'"></span>
      </h1>
    </div>

    <div v-if="filtersRequiredSet">
      <div v-show="!loadingData">
        <div class="kpis items">
          <div class="indicator-item dynamic-color animate__animated animate__fadeInRight" v-for="(item, index) in kpis" :key="item.name" @click="chartIndexSelected = index" :style="{ 'animation-delay': index * 50 + 'ms' }">
            <i class="fal" :class="[item.icon]"></i>
            <h1>{{ item.value | formatNum }} {{ item.suffix }}</h1>
            <label v-html="item.name"/>
          </div>
        </div>

        <div class="kpis animate__animated animate__fadeIn" v-if="printingReport || chartIndexSelected === -1">
          <h2>Concentrado por día</h2>
          <div class="kpi-item chart">
            <LineChart :chartdata="datacollection.general" :options="{ responsive: true,  maintainAspectRatio: false, legend: { display: true }, tooltips: chartsTooltips, scales: chartsScales, plugins: chartsPlugins }" style="position: relative; height:275px; width:100%"/>
          </div>
        </div>

        <div class="kpis animate__animated animate__fadeIn" v-if="printingReport || chartIndexSelected === 0">
          <h2>Tareas realizadas por día</h2>
          <div class="kpi-item chart">
            <LineChart :chartdata="datacollection.workedTasks" :options="{ responsive: true,  maintainAspectRatio: false, legend: { display: false }, tooltips: chartsTooltips, scales: chartsScales, plugins: chartsPlugins }" style="position: relative; height:275px; width:100%"/>
          </div>
        </div>

        <div class="kpis animate__animated animate__fadeIn" v-if="printingReport || chartIndexSelected === 1">
          <h2>Usuarios productivos por día</h2>
          <div class="kpi-item chart">
            <LineChart :chartdata="datacollection.usersWithAtLeastOneTask" :options="{ responsive: true,  maintainAspectRatio: false, legend: { display: false }, tooltips: chartsTooltips, scales: chartsScales, plugins: chartsPlugins }" style="position: relative; height:275px; width:100%"/>
          </div>
        </div>

        <div class="kpis animate__animated animate__fadeIn page-break" v-if="printingReport || chartIndexSelected === 2">
          <h2>Porcentaje de usuarios que han trabajado por día</h2>
          <div class="kpi-item chart">
            <LineChart :chartdata="datacollection.precentageUsersWhoWorked" :options="{ responsive: true,  maintainAspectRatio: false, legend: { display: false }, tooltips: chartsTooltips, scales: chartsScales, plugins: chartsPlugins }" style="position: relative; height:275px; width:100%"/>
          </div>
        </div>

        <div class="kpis animate__animated animate__fadeIn" v-if="printingReport || chartIndexSelected === 3">
          <h2>Promedio de tareas gestionadas por día</h2>
          <div class="kpi-item chart">
            <LineChart :chartdata="datacollection.averageWorkedTasks" :options="{ responsive: true,  maintainAspectRatio: false, legend: { display: false }, tooltips: chartsTooltips, scales: chartsScales, plugins: chartsPlugins }" style="position: relative; height:275px; width:100%"/>
          </div>
        </div>

        <div class="kpis animate__animated animate__fadeIn" v-if="printingReport || chartIndexSelected === 4">
          <h2>Promedio de horas trabajadas por día</h2>
          <div class="kpi-item chart">
            <LineChart :chartdata="datacollection.avegareWorkedHours" :options="{ responsive: true,  maintainAspectRatio: false, legend: { display: false }, tooltips: chartsTooltips, scales: chartsScales, plugins: chartsPlugins }" style="position: relative; height:275px; width:100%"/>
          </div>
        </div>

        <div class="charts-control">
          <span @click="chartIndexSelected = -1" v-if="chartIndexSelected !== -1">Concentrado</span>
          <span @click="prevChart"><i class="fas fa-angle-left"></i></span>
          <span @click="nextChart"><i class="fas fa-angle-right"></i></span>
        </div>

        <div class="kpis page-break">
          <h2>Detalle de subgrupos</h2>

          <table class="table table-hover detail cpd">
            <thead class="table-header">
              <tr>
                <th scope="col" style="padding-top: 20px; width: 170px;">Grupo</th>
                <td scope="col">Tareas<br>trabajadas</td>
                <td scope="col">Usuarios<br>productivos</td>
                <td scope="col">Promedio tareas<br>gestionadas</td>
                <td scope="col">Promedio horas<br>trabajadas</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dataItems" :key="index">
                <th class="group-name" style="width: 170px;" :title="item.groupName">{{ item.groupName }}</th>
                <td><TableKpiItem name="Tareas trabajadas" :amount="item.workedTasksCount" :total="dataItems[0].workedTasksCount" color="green"/></td>
                <td><TableKpiItem name="Usuarios productivos" :amount="item.usersWithAtLeastOneTask" :total="item.totalUsers" :includeTotal="true" color="yellow"/></td>
                <td><TableKpiItem name="Promedio de tareas gestionadas" :amount="item.averageWorkedTasks" :total="averageWorkedTasksMax" :amountToCompare="dataItems[0].averageWorkedTasks" :hidePercent="true" color="purple"/></td>
                <td><TableKpiItem name="Promedio de horas trabajadas" :amount="item.avegareWorkedHours" :total="averageWorkedHoursMax" :amountToCompare="dataItems[0].avegareWorkedHours" :hidePercent="true" color="pink"/></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!--div class="kpis actions" v-if="!usersDisplayed">
          <b-button class="shadow-sm" variant="primary" size="md" @click="showUsers"><i class="far fa-users"></i>&nbsp;&nbsp;Mostrar detalle de licencias</b-button>
        </div-->

        <div class="kpis page-break" v-if="usersDisplayed && dataUserItems.length">
          <h2>Detalle de licencias</h2>

          <table class="table table-hover detail users scrolled">
            <thead class="table-header">
              <tr v-if="!printingReport && dataUserItems && dataUserItems.length >= 20">
                <th colspan="2">
                  <div class="table-filters">
                    <b-form-input v-model="searchUsers" placeholder="Buscar usuarios"></b-form-input>
                  </div>
                </th>
              </tr>
              <tr>
                <th scope="col" style="padding-top: 20px; width: 170px;">Usuario</th>
                <td scope="col">Tareas<br>trabajadas</td>
                <td scope="col">Promedio diario de<br>tareas trabajadas</td>
                <td scope="col">Promedio de horas<br>trabajadas</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dataUserItems" :key="index" v-show="item.userName.includes(searchUsers)">
                <th class="group-name" style="width: 170px;" :title="item.userName">{{ item.userName }}</th>
                <td><TableKpiItem name="Tareas trabajadas" :amount="item.workedTasksCount" :total="mainDataKpis.workedTasksCount" :hidePercent="true" color="green"/></td>
                <td><TableKpiItem name="Promedio diario de tareas trabajadas" :amount="item.averageWorkedTasks" :total="mainDataKpis.averageWorkedTasks" :amountToCompare="mainDataKpis.averageWorkedTasks" :hidePercent="true" color="purple"/></td>
                <td><TableKpiItem name="Promedio de horas trabajadas" :amount="item.avegareWorkedHours" :total="mainDataKpis.avegareWorkedHours" :amountToCompare="mainDataKpis.avegareWorkedHours" :hidePercent="true" color="pink"/></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="loadingData" class="mock-loading">
        <div class="kpis items">
          <div class="indicator-item animate__animated animate__shakeX" v-for="index in 5" :key="index"></div>
        </div>

        <div class="kpis">
          <div class="kpi-item chart animate__animated animate__shakeX"></div>
        </div>
      </div>

    </div>

    <div v-else class="default-image">
      <img src="@/assets/img/reports/users-productivity.svg">
    </div>

    <a class="hidden-csv-download-link" ref="csvDownload1"></a>
    <a class="hidden-csv-download-link" ref="csvDownload2"></a>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import moment from 'moment'
import { AbstractReportComponent } from './AbstractReportComponent'
import reportsService from '@/services/ReportsService'
import { KpiItem, KpiUserProductivityDate, KpisProductivity, FiltersDateFormats, KpisUserProductivity } from '@/types/Dashboard'
import TableKpiItem from '@/components/dashboard/TableKpiItem.vue'
import LineChart from '@/components/charts/LineChart.vue'
import Colors from '@/types/Colors'
import { PageRequest } from '@/types/Support'
import { PageRequestTrackingFilters } from '@/types/Tracking'

@Component({
  components: {
    TableKpiItem,
    LineChart
  },
  filters: {
    formatNum (value: number) {
      return value.toLocaleString('en')
    }
  }
})
export default class ReportCapacidadProductividad extends AbstractReportComponent {
  data: KpiUserProductivityDate[]
  granularData: any[] = []

  // Main KPIs
  kpis: KpiItem[] = []
  mainDataKpis: KpisProductivity

  // KPIs by subgroups
  dataItems: KpisProductivity[] = []
  averageWorkedTasksMax = 0
  averageWorkedHoursMax = 0

  // KPIs by user
  dataUserItems: KpisUserProductivity[] = []

  // Charts
  datacollection: any = {
    workedTasks: null,
    usersWithAtLeastOneTask: null,
    precentageUsersWhoWorked: null,
    averageWorkedTasks: null,
    avegareWorkedHours: null,
    general: null
  }

  chartIndexSelected = -1

  chartsTooltips = {
    callbacks: {
      label: (tooltipItem: any, data: any) => {
        let valueNum = Number(tooltipItem.yLabel || 0)
        return valueNum.toLocaleString('en')
      }
    }
  }

  chartsScales = {
    yAxes: [{
      ticks: {
        beginAtZero: true,
        callback: (value: any) => {
          let valueNum = Number(value || 0)
          return valueNum.toLocaleString('en')
        }
      }
    }]
  }

  chartsPlugins = {
    datalabels: {
      display: false
    }
  }

  searchUsers = ''
  usersDisplayed = false

  created () {
    this.$store.commit('global/updateFiltersReportCapacidadProductividad')
  }

  mounted () {
    this.initialPageTitle = document.title
    this.filter(this.$route.query as any)
    this.$root.$on('export-report', this.exportReport)
    window.addEventListener('afterprint', this.afterPrintPdfReport)
  }

  beforeDestroy () {
    document.title = this.initialPageTitle
    this.$root.$off('export-report', this.exportReport)
    window.removeEventListener('afterprint', this.afterPrintPdfReport)
  }

  get filtersRequiredSet () {
    return !!this.filters.template && !!this.filters.group
  }

  async refreshData () {
    if (!this.filtersRequiredSet) return

    this.loadingData = true
    this.$store.commit('global/lockReportFilters', true)
    this.chartIndexSelected = -1
    this.dataItems = []
    this.dataUserItems = []
    this.usersDisplayed = false
    this.granularData = []

    try {
      let totalUsers = 0
      await reportsService.getCapacidadProductividad(this.filters)
        .then((response) => {
          this.data = response.dates
          totalUsers = response.total
        })
        .catch((error) => {
          this.$bvToast.toast(
            `Error al consultar la información del reporte: ${error.response.data.message}.
            Por favor, intenta con otros valores de consulta.
            `,
            { title: 'Error en la consulta', variant: 'danger', autoHideDelay: 6000 })
          this.endPrint()
          this.$store.commit('global/lockReportFilters', false)
        })

      this.mainDataKpis = reportsService.getGroupProductivityKpis(this.filtersStore.groupObject, this.data, totalUsers)

      this.refreshMainKpis(this.mainDataKpis)

      this.refreshChartsKpis(this.data, totalUsers)

      setTimeout(() => {
        this.refreshSubGroupsDetailKpis(this.mainDataKpis)
      }, 100)

      if (!this.filtersStore.groupObject.subGroups || !this.filtersStore.groupObject.subGroups.length) {
        this.refreshUsersDetailKpis(this.data)
        this.usersDisplayed = true
      }
    } finally {
      setTimeout(() => {
        this.loadingData = false
      }, 500)
    }
  }

  refreshFiltersInfo () {
    let result = []

    if (this.filtersStore.template) {
      result.push(this.filtersStore.templateName)
    }

    if (this.filtersStore.group) {
      result.push('Grupo: ' + this.filtersStore.groupName)
    }

    let dateRange = ''
    if (this.filtersStore.initDate !== this.filtersStore.endDate) {
      dateRange += 'Del ' + moment(this.filtersStore.initDate, FiltersDateFormats.QUERY_STRING).format('D [de] MMMM')
      dateRange += ' al ' + moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('D [de] MMMM [de] YYYY')
    } else {
      dateRange += 'Del día ' + moment(this.filtersStore.initDate, FiltersDateFormats.QUERY_STRING).format('D [de] MMMM [de] YYYY')
    }
    result.push(dateRange)
    this.filtersHead = result.join(', ')
  }

  refreshMainKpis (dataKpis: KpisProductivity) {
    this.kpis = []

    this.kpis.push(
      KpiItem.getInstance().withName('Tareas<br>realizadas').withValue(dataKpis.workedTasksCount).withIcon('fa-map-marker-check')
    )

    this.kpis.push(
      KpiItem.getInstance().withName('Usuarios<br>productivos').withValue(dataKpis.usersWithAtLeastOneTask).withIcon('fa-walking')
    )

    this.kpis.push(
      KpiItem.getInstance().withName('Usuarios que<br>han trabajado').withValue(dataKpis.precentageUsersWhoWorked).withSuffix('%').withIcon('fa-street-view')
    )

    this.kpis.push(
      KpiItem.getInstance().withName('Promedio de tareas<br>gestionadas').withValue(dataKpis.averageWorkedTasks).withIcon('fa-clipboard-list-check')
    )

    this.kpis.push(
      KpiItem.getInstance().withName('Promedio de horas<br>trabajadas').withValue(dataKpis.avegareWorkedHours).withIcon('fa-clock')
    )
  }

  refreshChartsKpis (data: KpiUserProductivityDate[], totalUsers: number) {
    let dataKpisArr: KpisProductivity[] = data.reduce((arr: KpisProductivity[], it: KpiUserProductivityDate) => {
      return arr.concat(reportsService.getGroupProductivityKpis(this.filtersStore.groupObject, data, totalUsers, it.date))
    }, [])

    const chartLabelsDates = dataKpisArr.reduce((arr: string[], it: KpisProductivity) => arr.concat(it.date), [])

    let datasets = [
      {
        label: 'Tareas realizadas',
        lineTension: 0.4,
        borderColor: Colors.green[0],
        backgroundColor: Colors.green[1] + '99',
        fill: true,
        data: dataKpisArr.reduce((arr: string[], it: KpisProductivity) => arr.concat(it.workedTasksCount.toString()), [])
      },
      {
        label: 'Usuarios productivos',
        lineTension: 0.4,
        borderColor: Colors.yellow[0],
        backgroundColor: Colors.yellow[1] + '99',
        fill: true,
        data: dataKpisArr.reduce((arr: string[], it: KpisProductivity) => arr.concat(it.usersWithAtLeastOneTask.toString()), [])
      },
      {
        label: '% Usuarios que han trabajado',
        lineTension: 0.4,
        borderColor: Colors.aqua[0],
        backgroundColor: Colors.aqua[1] + '99',
        fill: true,
        data: dataKpisArr.reduce((arr: string[], it: KpisProductivity) => arr.concat(it.precentageUsersWhoWorked.toString()), [])
      },
      {
        label: 'Promedio de tareas gestionadas',
        lineTension: 0.4,
        borderColor: Colors.purple[0],
        backgroundColor: Colors.purple[1] + '99',
        fill: true,
        data: dataKpisArr.reduce((arr: string[], it: KpisProductivity) => arr.concat(it.averageWorkedTasks.toString()), [])
      },
      {
        label: 'Promedio de horas trabajadas',
        lineTension: 0.4,
        borderColor: Colors.pink[0],
        backgroundColor: Colors.pink[1] + '99',
        fill: true,
        data: dataKpisArr.reduce((arr: string[], it: KpisProductivity) => arr.concat(it.avegareWorkedHours.toString()), [])
      }
    ]
    this.datacollection.workedTasks = {
      labels: chartLabelsDates,
      datasets: [ datasets[0] ]
    }

    this.datacollection.usersWithAtLeastOneTask = {
      labels: chartLabelsDates,
      datasets: [ datasets[1] ]
    }

    this.datacollection.precentageUsersWhoWorked = {
      labels: chartLabelsDates,
      datasets: [ datasets[2] ]
    }

    this.datacollection.averageWorkedTasks = {
      labels: chartLabelsDates,
      datasets: [ datasets[3] ]
    }

    this.datacollection.avegareWorkedHours = {
      labels: chartLabelsDates,
      datasets: [ datasets[4] ]
    }

    this.datacollection.general = {
      labels: chartLabelsDates,
      datasets: [
        Object.assign({}, datasets[0], { fill: false }),
        Object.assign({}, datasets[1], { fill: false }),
        Object.assign({}, datasets[2], { fill: false }),
        Object.assign({}, datasets[3], { fill: false }),
        Object.assign({}, datasets[4], { fill: false })
      ]
    }
  }

  refreshSubGroupsDetailKpis (mainDataKpis: KpisProductivity) {
    this.dataItems = []
    let groupKpis = null

    setTimeout(async () => {
      this.dataItems.push(mainDataKpis)

      this.averageWorkedTasksMax = mainDataKpis.averageWorkedTasks
      this.averageWorkedHoursMax = mainDataKpis.avegareWorkedHours

      for (let it of this.filtersStore.groupObject.subGroups) {
        try {
          const filters = Object.assign({}, this.filters)
          filters.group = it.id
          var data: KpiUserProductivityDate[] = []
          let totalUsers = 0
          await reportsService.getCapacidadProductividad(filters).then((response) => {
            data = response.dates
            totalUsers = response.total
          })

          groupKpis = reportsService.getGroupProductivityKpis(it, data, totalUsers)

          this.averageWorkedTasksMax = groupKpis.averageWorkedTasks > this.averageWorkedTasksMax ? groupKpis.averageWorkedTasks : this.averageWorkedTasksMax
          this.averageWorkedHoursMax = groupKpis.avegareWorkedHours > this.averageWorkedHoursMax ? groupKpis.avegareWorkedHours : this.averageWorkedHoursMax

          this.dataItems.push(groupKpis)

          this.granularData.push({
            group: it,
            totalUsers: totalUsers,
            data: data
          })
        } catch (error) {
          this.$bvToast.toast(`Ocurrió un error al recuperar los datos del subgrupo ${it.name}.`, {
            title: 'Error de conexión',
            autoHideDelay: 5000,
            toaster: 'b-toaster-top-left',
            variant: 'danger'
          })
        }
      }

      this.$store.commit('global/lockReportFilters', false)
    }, 1000)
  }

  refreshUsersDetailKpis (data: KpiUserProductivityDate[]) {
    let users: any = {}

    for (let it of data) {
      for (let itUsr of it.users) {
        users[itUsr.user] = users[itUsr.user] || new KpisUserProductivity()
        users[itUsr.user].userName = itUsr.user
        users[itUsr.user].workedDays++
        users[itUsr.user].workedTasksCount += itUsr.worked_amount
        users[itUsr.user].workedHoursCount += itUsr._workedHoursNumber
      }
    }

    let userItems = []

    for (let it of Object.values(users) as KpisUserProductivity[]) {
      it.averageWorkedTasks = Number((it.workedTasksCount / it.workedDays).toFixed(1))
      it.avegareWorkedHours = Number((it.workedHoursCount / it.workedDays).toFixed(1))
      userItems.push(it)
    }

    this.dataUserItems = userItems.sort((a, b) => (a.userName > b.userName) ? 1 : -1)
  }

  prevChart () {
    if (this.chartIndexSelected > -1) this.chartIndexSelected--
    else this.chartIndexSelected = this.kpis.length - 1
  }

  nextChart () {
    if (this.chartIndexSelected + 1 < this.kpis.length) this.chartIndexSelected++
    else this.chartIndexSelected = -1
  }

  private getPageRequestForTotalUsers () {
    let pageRequest = new PageRequest<PageRequestTrackingFilters>(1)
    pageRequest.filters.onlyMobileUsers = false
    pageRequest.filters.from = moment(this.filters.initDate, FiltersDateFormats.FROM_QUERY_STRING).set({ hour: 0, minute: 0, second: 0 }).toDate().getTime()
    pageRequest.filters.to = moment(this.filters.endDate, FiltersDateFormats.FROM_QUERY_STRING).set({ hour: 23, minute: 59, second: 59 }).toDate().getTime()
    return pageRequest
  }

  showUsers () {
    this.refreshUsersDetailKpis(this.data)
    this.usersDisplayed = true
  }

  exportReport (reportType: string) {
    switch (reportType) {
      case 'pdf':
        this.generatePdfReport()
        break
      case 'csv':
        this.generateCsvReportGrupos()
        this.generateCsvReportLicencias()
        break
    }
  }

  generatePdfReport () {
    this.validateRatio()
    this.searchUsers = ''
    this.startPrint()
    setTimeout(() => {
      const periodTitle = moment(this.filtersStore.initDate, FiltersDateFormats.QUERY_STRING).format('DDMMYYYY') + '-' + moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('DMMYYYY')
      document.title = `${periodTitle}_${this.filtersStore.templateName}_${this.filtersStore.groupName}_RptCapacidad`
      window.print()
    }, 1200)
  }

  generateCsvReportGrupos () {
    let period = moment(this.filtersStore.initDate, FiltersDateFormats.QUERY_STRING).format('D/MM/YYYY') + ' - ' + moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('D/MM/YYYY')

    let csvGroups = 'TEMPLATE,GRUPO,SUBGRUPO,FECHA,TAREAS REALIZADAS,USUARIOS PRODUCTIVOS,% USUARIOS QUE HAN TRABAJADO,PROMEDIO DE TAREAS GESTIONADAS,PROMEDIO DE HORAS TRABAJADAS\n'
    csvGroups += `${this.filtersStore.templateName},${this.filtersStore.groupName},,${period},${this.mainDataKpis.workedTasksCount},${this.mainDataKpis.usersWithAtLeastOneTask},${this.mainDataKpis.precentageUsersWhoWorked} %,${this.mainDataKpis.averageWorkedTasks},${this.mainDataKpis.avegareWorkedHours}\n`

    for (let subgroup of this.granularData) {
      subgroup.data.forEach((it: KpiUserProductivityDate) => {
        period = moment(it.date, FiltersDateFormats.FROM_QUERY_STRING).format('D/MM/YYYY')
        let kpisItem = reportsService.getGroupProductivityKpis(subgroup.group, subgroup.data, subgroup.totalUsers, it.date)
        csvGroups += `${this.filtersStore.templateName},${this.filtersStore.groupName},${subgroup.group.name},${period},${kpisItem.workedTasksCount},${kpisItem.usersWithAtLeastOneTask},${kpisItem.precentageUsersWhoWorked} %,${kpisItem.averageWorkedTasks},${kpisItem.avegareWorkedHours}\n`
      })
    }

    const periodTitle = moment(this.filtersStore.initDate, FiltersDateFormats.QUERY_STRING).format('DDMMYYYY') + '-' + moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('DMMYYYY')

    let element = this.$refs.csvDownload1 as any
    element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvGroups)
    element.target = '_blank'
    element.download = `${periodTitle}_${this.filtersStore.templateName}_${this.filtersStore.groupName}_RptCapacidad.csv`
    element.click()
  }

  generateCsvReportLicencias () {
    if (!this.usersDisplayed) return

    let period = moment(this.filtersStore.initDate, FiltersDateFormats.QUERY_STRING).format('D/MM/YYYY') + ' - ' + moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('D/MM/YYYY')

    let csvLicencias = 'TEMPLATE,GRUPO,LICENCIA/GRUPO,FECHA,TAREAS REALIZADAS,HORAS TRABAJADAS\n'
    csvLicencias += `${this.filtersStore.templateName},${this.filtersStore.groupName},${this.filtersStore.groupName},${period},${this.mainDataKpis.workedTasksCount},${this.mainDataKpis.workedHoursCount.toFixed(1)}\n`

    for (let user of this.dataUserItems) {
      for (let it of this.data) {
        period = moment(it.date, FiltersDateFormats.FROM_QUERY_STRING).format('D/MM/YYYY')
        for (let itUsr of it.users) {
          if (user.userName === itUsr.user) {
            csvLicencias += `${this.filtersStore.templateName},${this.filtersStore.groupName},${user.userName},${period},${itUsr.worked_amount},${itUsr._workedHoursNumber.toFixed(1)}\n`
          }
        }
      }
    }

    const periodTitle = moment(this.filtersStore.initDate, FiltersDateFormats.QUERY_STRING).format('DDMMYYYY') + '-' + moment(this.filtersStore.endDate, FiltersDateFormats.QUERY_STRING).format('DMMYYYY')

    let element = this.$refs.csvDownload2 as any
    element.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvLicencias)
    element.target = '_blank'
    element.download = `${periodTitle}_${this.filtersStore.templateName}_${this.filtersStore.groupName}_RptCapacidad_Licencias.csv`
    element.click()
  }

  afterPrintPdfReport () {
    this.endPrint()
    document.title = this.initialPageTitle
  }
}
</script>

<style lang="scss" scoped>
.default-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100% - 120px);
  overflow: visible;
  img {
    width: 50%;
    min-width: 350px;
    opacity: 0.2;
  }
}
.table-filters {
  width: 350px;
  margin: 10px 0;
}
</style>
